module.exports = __webpack_public_path__ + "static/media/015.569e3ee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/015.jpg
// module id = 312
// module chunks = 0